import React from "react";
import { PageHeader } from "@/components/kit/PageHeader";
import { BillingSuperAdmin } from "@/components/settings/BillingSuperAdmin";

export default function SuperBilling() {
  return (
    <div className="space-y-6" data-testid="super-billing">
      <PageHeader title="Billing" subtitle="SaaS plans, tenant subscriptions, trials, renewals & payments." />
      <BillingSuperAdmin />
    </div>
  );
}
